import React from 'react'
import { FastField, useFormikContext } from 'formik'

import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'

import {
  useGroupsQuery,
  useCreateGroupMutation,
  useUpdateGroupMutation,
  useDeleteGroupMutation,
} from '../../services/stream-manager'
import { withAdmin } from '../../services/msal'

import usePaginatedFilteredQuery from '../../hooks/usePaginatedFilteredQuery'
import useMapValuesToArg from '../../hooks/useMapValuesToArg'

import EnhancedTable from '../table/EnhancedTable'
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const GroupFormFields = () => {
  const { values, setFieldValue } = useFormikContext();
  const [userDidAcceptDisclaimer, setUserDidAcceptDisclaimer] = React.useState(!!values.days_till_expiry_users);

  return (
  <>
    <FastField name="group">
      {({ field, meta }) => (
        <TextField
          {...field}
          autoFocus
          label="Group"
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          margin="dense"
          fullWidth
          disabled={meta.initialValue !== ''}
        />
      )}
    </FastField>
    <FastField name="description">
      {({ field, meta }) => (
        <TextField
          {...field}
          label="Description"
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          margin="dense"
          fullWidth
        />
      )}
    </FastField>
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            name="expiry_disclaimer"
            checked={userDidAcceptDisclaimer}
            onChange={() => {
              setFieldValue(
                'days_till_expiry_users',
                {
                  ...values.days_till_expiry_users,
                  disabled: !userDidAcceptDisclaimer,
                }
              )
              setUserDidAcceptDisclaimer(!userDidAcceptDisclaimer)
            }}
          />}
        label={
          <span>
            Enable <b>Days to expiry</b>.
          </span>
        }
      />
      <span>Warning: only use this when user-access to a group must expire after a defined period of being granted access.</span>

    </FormGroup>

    <FastField name="days_till_expiry_users">
      {({ field, meta }) => (
        <TextField
          {...field}
          label="Days to expiry"
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          margin="dense"
          fullWidth
          type="number"
          disabled={!userDidAcceptDisclaimer}
        />
      )}
    </FastField>
 </>
  )
}

const mapValuesToArg = (diff, args) => {
  // When creating/updating groups, the payload must always contain all values for all fields,
  // even if they are not being updated.
  let body = {};

  if (args && Array.isArray(args) && args.length > 0) {
    body = {
      ...args[0],
      ...diff,
    }
  } else {
    body = diff;
  }

  if (body?.id) {
    body.group = body.id;
    // the API expects the "id" field to actually be named "group"
    delete body.id;
  }
  // Convert to integer
  body.days_till_expiry_users = parseInt(body.days_till_expiry_users);
  if (isNaN(body.days_till_expiry_users)) {
    body.days_till_expiry_users = null;
  }
  return ({ body });
}

const groupColumns = [
  {
    Header: 'Group',
    accessor: 'group',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Days To Expire For Users',
    accessor: 'days_till_expiry_users',
  }
]

const GroupManagement = () => (
  <Paper>
    <EnhancedTable
      search
      label="Group"
      columns={groupColumns}
      FormFields={GroupFormFields}
      itemsQuery={usePaginatedFilteredQuery(useGroupsQuery)()}
      createMutation={useMapValuesToArg(useCreateGroupMutation, mapValuesToArg)}
      updateMutation={useMapValuesToArg(useUpdateGroupMutation, mapValuesToArg)}
      deleteMutation={useDeleteGroupMutation()}
      pagination={false}
    />
  </Paper>
)

export const GroupManagementPage = withAdmin(GroupManagement)
